/* eslint-disable no-param-reassign */

import produce from 'immer'

import { OPEN_LK_MODAL, CLOSE_LK_MODAL } from './actions'

export const REDUCER_NAME = 'Modals'

export const getModals = (state, name) => state[REDUCER_NAME][name] || {}

// interface LKModalState {
//   name: string;
//   open: boolean;
//   message?: string;
//   params: Object;
// }

// interface LKModalReducerState {
//   [key: string]: LKModalState;
// }

// interface LKModalOpenAction {
//   type: typeof OPEN_LK_MODAL | typeof CLOSE_LK_MODAL;
//   payload: {
//     name: string,
//     message?: string,
//     params: Object, // all kind of crap
//   };
// }

const reducer = produce((draft, action) => {
  switch (action.type) {
    case OPEN_LK_MODAL: {
      const { name, message, params, onclose } = action.payload
      if (draft[name]) {
        console.warn('modal with such name already exists') // eslint-disable no-console
        return
      }

      draft[name] = {
        name,
        message,
        params,
        open: true,
        onclose,
      }
      break
    }

    case CLOSE_LK_MODAL: {
      const { name } = action.payload

      delete draft[name]
    }
  }
}, {})

export default reducer
